import React from "react";
import PageHeader from "./global-components/page-header";
import DigitalniMarketing from "./section-components/digitalni-marketing";
import Footer from "./global-components/footer";

const DigitalniMarketingPage = () => {
  return (
    <div>
      <PageHeader headertitle="Digitalni marketing" />
      <DigitalniMarketing />
      <Footer />
    </div>
  );
};

export default DigitalniMarketingPage;
